import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, Button, Card, Typography } from '@mui/material';
import { formatDuration, intervalToDuration } from 'date-fns';
import { fr } from 'date-fns/locale';
import React from 'react';
import ArrowReturnIcon from '../../../../../svg-icons/ArrowReturnIcon';

const RetractLegalDelayOverDue = ({
  legalDelayOverDue,
  handleShowComponent,
  store,
}) => {
  const formatOverdueDays = (days) => {
    const duration = intervalToDuration({
      start: 0,
      end: days * 24 * 60 * 60 * 1000,
    });

    return formatDuration(duration, {
      locale: fr,
      format: ['years', 'months', 'weeks', 'days'],
      zero: false,
      delimiter: ' et ',
    });
  };

  return (
    <>
      <Card
        elevation={5}
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
          padding: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <HighlightOffIcon fontSize="large" color="error" />
            <Typography color="primary">
              Délai de rétractation dépassé
            </Typography>
          </Box>
          <Button
            onClick={() => handleShowComponent(null)}
            variant="outlined"
            size="small"
            sx={{ position: 'absolute', top: 16, left: 16 }}
          >
            <ArrowReturnIcon fontSize="small" />
            <span style={{ marginLeft: 4, fontSize: '0.9em' }}>Retour</span>
          </Button>
        </Box>
      </Card>

      <Box
        sx={{
          mt: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
          gap: 4,
        }}
      >
        <Typography variant="body1" align="left">
          Le délai légal de rétractation pour <strong>{store?.name}</strong> est
          de <strong>{store?.legalRetractTime} jours</strong>.
        </Typography>
        {!store?.hasRetractFees && (
          <Typography variant="body1" align="left">
            Les CGV de cette marketplace ne prévoient pas de frais de
            rétractation pendant ce délai.
          </Typography>
        )}

        <Typography variant="body1" align="left">
          Le délai légal de rétractation est dépassé de{' '}
          <strong>{formatOverdueDays(legalDelayOverDue)}</strong>,
          souhaitez-vous quand même effectuer une demande de rétractation ?
        </Typography>

        <Box sx={{ display: 'flex', alignSelf: 'center', gap: 2 }}>
          <Button
            variant="outlined"
            color="info"
            onClick={() => handleShowComponent(null)}
          >
            Annuler
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleShowComponent('retractOrderSAV', true)}
          >
            Continuer
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default RetractLegalDelayOverDue;
